import type { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'

// * http 响应
export enum ResultEnum {
  SUCCESS = 200,
  UNAUTHORIZED = 401,
  ERROR = 500,
  OVERDUE = 599,
  TIMEOUT = 60000,
  TYPE = 'success',
}

// * 请求方法
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

// *常用的contentType类型
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // text
  TEXT = 'text/plain;charset=UTF-8',
  // form-data 一般配合qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data 上传
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

// * responseType类型
export enum ResponseTypeEnum {
  ARRAY_BUFFER = 'arraybuffer',
  BLOB = 'blob',
}

// export interface Result<T = any> extends Pick<AxiosResponse, 'statusText' | 'headers' | 'config'> {
export interface Result<T = any> {
  return_msg?: string
  return_code?: number
  content?: T
  status: number
  msg: string
  code: number
  data: T
  blob?: any
  fileName?: string
}

export interface ResponseModel<T = any> {
  return_msg?: string
  return_code?: number
  content?: T
  status: number
  msg: string
  code: number
  data: T
  blob?: any
  fileName?: string
}

export type Params = Partial<Record<string, unknown>>
export type Config = Omit<AxiosRequestConfig, 'url' | 'method'>
export type RequestConfig = InternalAxiosRequestConfig

export interface BoResponse<T> {
  content: T
  return_msg: string
  return_code: string
}

export interface RbResponse<T> extends Partial<BoResponse<T>> {
  data: T
  code: number
  msg: string
  success: boolean
  blob?: any
  fileName?: string
}
